import baseService from '@/utils/http/axios'

/**
 * * usb电话机
 * http://www.hion.cn/article/15.html
 * u880
 */
const usbphone = {
    state: {
        token: 'tttt',
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        }
    },
    actions: {
        Test({ commit }, token) {
            commit('SET_TOKEN', token)

        },
    },
    namespaced: true//启用名称空间
}
export default usbphone
